import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const OperatorSettlementConfig = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.CITY_OPERATOR:
      return { ...state, cityOperatorsList: action.value };
    case actions.SETTLEMENT_CYCLE:
      return { ...state, isSettlementCycleSaved: action.value };
    default:
      return state;
  }
};

export default OperatorSettlementConfig;
